import axios from "axios";

const env = (typeof process !== "undefined" && process.env) || {};

const resolveApiBase = () => {
  const envBase = env.REACT_APP_API_BASE_URL || env.REACT_APP_API_URL || "";
  if (typeof window === "undefined") return envBase || "";
  if (!envBase) return "";
  if (env.NODE_ENV !== "production" && envBase.replace(/\/$/, "") === window.location.origin.replace(/\/$/, "")) {
    return "";
  }
  return envBase;
};

const apiBase = resolveApiBase();

const api = axios.create({
  baseURL: `${apiBase.replace(/\/$/, "")}/api`,
  timeout: 20_000,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("adminAccessToken") ||
    localStorage.getItem("hv_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Provider reads are safe to retry once when the network briefly drops or the
// upstream gateway returns a transient error. Mutating booking/payment calls
// are deliberately never retried to prevent duplicate transactions.
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;
    const method = String(config?.method || "get").toLowerCase();
    const status = Number(error?.response?.status || 0);
    const transient = !error?.response || status === 408 || status === 429 || status >= 500;
    if (!config || method !== "get" || config.__homevilasRetried || !transient) {
      return Promise.reject(error);
    }
    config.__homevilasRetried = true;
    await new Promise((resolve) => setTimeout(resolve, 350));
    return api.request(config);
  }
);

export default api;


